// @ts-strict-ignore
import queryString from 'query-string';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { TileCarousel } from 'components/TileCarousel';
import { State as MainState } from 'store/main';
import { JobFunction } from 'utils/constants';
import { useCarouselRecommendedJobs } from 'utils/hooks/useCarouselRecommendedJobs';
import { listingSearchHomePath } from 'utils/searchHomePages';

type StandardCmsRecommendedJobsProps = {
  headline: string;
  layout: 'SLIM' | 'REGULAR';
  jobFunction: JobFunction | null | undefined;
  source: 'RECOMMENDED_JOBS_CHECKBOX' | 'RECOMMENDED_JOBS_BLOCK';
};

export function StandardCmsRecommendedJobs({
  headline,
  layout,
  jobFunction,
  source,
}: StandardCmsRecommendedJobsProps) {
  const history = useHistory();
  const searchLocation = useSelector<MainState>(
    (state) => state.mainSearch.searchLocation
  ) as SearchLocation;

  const recommendedJobs = useCarouselRecommendedJobs({
    searchLocation,
    options: {
      onlyWithLogo: layout === 'REGULAR',
      jobFunction,
    },
  });
  if (!recommendedJobs) return null;
  const seeAllQueryString = queryString.stringify(
    {
      searchMode: true,
      q: '',
      functions: [jobFunction],
    },
    {
      skipNull: true,
    }
  );
  const additionalAnalyticsProps = {};
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'job_function' does not exist on type '{}... Remove this comment to see the full error message
  if (jobFunction) additionalAnalyticsProps.job_function = jobFunction;
  return (
    <TileCarousel
      headline={headline}
      results={recommendedJobs}
      // @ts-expect-error ts-migrate(2322) FIXME: Type '{ headline: string; results: TileCarouselRes... Remove this comment to see the full error message
      history={history}
      seeAllText={
        /* TRANSLATORS: Link to job search */
        getText('See all jobs')
      }
      seeAllUrl={`${listingSearchHomePath('JOB')}?${seeAllQueryString}`}
      listingType="JOB"
      carouselLocation="CMS Page"
      layout={layout}
      source={source}
      additionalAnalyticsProps={additionalAnalyticsProps}
    />
  );
}
